import { z } from 'zod';

export const isEmailValueValid = (email: string): boolean => {
  // for some MGO email contains ', we need exclude the special character '
  const looseEmail = email.replace(/.*?@/, (match) => match.replace(/'/g, ''));
  return z.string().email().safeParse(looseEmail).success;
};
